import { ResponseWrapper } from 'src/api/endpoints/users/users.types.new';
import { baseApi, QueryPayload } from 'src/api';
import {
    AddTimetableArg,
    DeleteTimetableArg,
    GetDataForCreateTimetableResult,
    GetTimetableScheduleArgs,
    GetTimetableScheduleResult,
    Lesson,
    RemoveTimetableRangeArg,
    UpdateTimetableArg,
} from 'src/api/endpoints/schedule/schedule.types';

const api = baseApi.injectEndpoints({
    endpoints: builder => ({
        getTimetableSchedule: builder.query<
            GetTimetableScheduleResult,
            GetTimetableScheduleArgs
        >({
            providesTags: ['Timetable'],
            query: ({ search, params }): QueryPayload => ({
                url: `/branches/${params.branchId}/lessons`,
                method: 'GET',
                errorMessage: 'Не удалось получить информацию о расписании!',
                params: search,
            }),
            transformResponse(val: any) {
                return val.map(el => {
                    return {
                        id: el.id,
                        startDate: el.startedAt,
                        endDate: el.finishedAt,
                        numberLesson: el.number,
                        teacher: el.teacher.fio,
                        teacherId: el.teacher.id,
                        curGroup: el.group.name,
                        curGroupId: el.group.id,
                        subject: el.subject.name,
                        subjectId: el.subject.id,
                        audience: el.audience.id,
                        audienceName: el.audience.name,
                    } as Lesson;
                });
            },
        }),
        getDataForCreateTimetable: builder.query<
            GetDataForCreateTimetableResult,
            { params: { branchId: number } }
        >({
            providesTags: ['Group', 'Audience', 'Subjects', 'User'],
            query: ({ params }): QueryPayload => ({
                url: `/branches/${params.branchId}/lessons/data/create`,
                method: 'GET',
                errorMessage:
                    'Не удалось получить информацию для создания расписания!',
            }),
            transformResponse(val: any) {
                return {
                    audiences: val.audiences,
                    subjects: val.subjects,
                    dataNameGroups: val.groups,
                    teachers: val.teachers,
                };
            },
        }),
        addTimetable: builder.mutation<ResponseWrapper<null>, AddTimetableArg>({
            invalidatesTags: ['Timetable'],
            query: ({body, params}): QueryPayload => ({
                url: `/branches/${params.branchId}/lessons`,
                method: 'POST',
                data: {
                    lessonNumber: body.number_lesson,
                    startsAt: body.start_date,
                    endsAt: body.end_date,
                    groupId: body.cur_group,
                    subjectId: body.subject,
                    teacherId: body.teacherId,
                    audienceId: body.audience,
                },
                errorMessage:
                    'Не удалось добавить расписание. Один из уроков создает пересечение в расписании!',
            }),
        }),
        updateTimetable: builder.mutation<
            ResponseWrapper<null>,
            UpdateTimetableArg
        >({
            invalidatesTags: ['Timetable'],
            query: (arg: UpdateTimetableArg): QueryPayload => ({
                url: `/lessons/${arg.id}`,
                method: 'PATCH',
                data: {
                    startsAt: arg.start_date,
                    endsAt: arg.end_date,
                    groupId: arg.cur_group,
                    subjectId: arg.subject,
                    teacherId: arg.teacherId,
                    audienceId: arg.audience,
                },
                errorMessage:
                    'Не удалось обновить расписание. Один из уроков создает пересечение в расписании!',
            }),
        }),
        deleteTimetable: builder.mutation<
            ResponseWrapper<null>,
            DeleteTimetableArg
        >({
            invalidatesTags: ['Timetable'],
            query: (arg: DeleteTimetableArg): QueryPayload => ({
                url: `/lessons/${arg.lessonId}`,
                method: 'delete',
                errorMessage: 'Не удалось удалить расписание!',
            }),
        }),
        deleteTimetableRange: builder.mutation<
            ResponseWrapper<null>,
            RemoveTimetableRangeArg
        >({
            invalidatesTags: ['Timetable'],
            query: (arg: RemoveTimetableRangeArg): QueryPayload => ({
                url: '/lessons/range',
                method: 'delete',
                data: {
                    startDate: arg.startDate,
                    finishDate: arg.finishDate,
                    groupId: arg.curGroup,
                    subjectId: arg.subjectId,
                },
                errorMessage: 'Не удалось удалить расписание!',
            }),
        }),
    }),
});

export const {
    useGetDataForCreateTimetableQuery,
    useDeleteTimetableRangeMutation,
    useGetTimetableScheduleQuery,
    useDeleteTimetableMutation,
    useUpdateTimetableMutation,
    useAddTimetableMutation: useCreateLessonMutation,
} = api;
